export default {"src":"/_next/static/media/Not Found.4b5e758a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};